import {
  GET_COMPANY_TO_USER_LIST,
  GET_COMPANY_TO_USER_LIST_SUCCESS,
  GET_COMPANY_TO_USER_LIST_FAILURE,
  SWITCH_COMPANY,
  SWITCH_COMPANY_SUCCESS,
  SWITCH_COMPANY_FAILURE,
  GET_COMPANY_USER_INVITATIONS,
  GET_COMPANY_USER_INVITATIONS_SUCCESS,
  GET_COMPANY_USER_INVITATIONS_FAILURE,
  SEND_EMAIL_INVITATION,
  SEND_EMAIL_INVITATION_SUCCESS,
  SEND_EMAIL_INVITATION_FAILURE,
  GET_JOIN_COMPANY_INVITATION_LIST,
  GET_JOIN_COMPANY_INVITATION_LIST_SUCCESS,
  GET_JOIN_COMPANY_INVITATION_LIST_FAILURE,
  ACCEPT_OR_DECLINE_INVITATION_TO_JOIN_COMPANY,
  ACCEPT_OR_DECLINE_INVITATION_TO_JOIN_COMPANY_SUCCESS,
  ACCEPT_OR_DECLINE_INVITATION_TO_JOIN_COMPANY_FAILURE,
  GET_COMPANY_TEAM_MEMBERS_LIST,
  GET_COMPANY_TEAM_MEMBERS_LIST_SUCCESS,
  GET_COMPANY_TEAM_MEMBERS_LIST_FAILURE,
  GET_COMPANY_DETAILS,
  GET_COMPANY_DETAILS_SUCCESS,
  GET_COMPANY_DETAILS_FAILURE,
  UPDATE_COMPANY_DETAILS,
  UPDATE_COMPANY_DETAILS_SUCCESS,
  UPDATE_COMPANY_DETAILS_FAILURE,
  GET_USER_AVAILABLE_MENU,
  GET_USER_AVAILABLE_MENU_SUCCESS,
  GET_USER_AVAILABLE_MENU_FAILURE,
  GET_USER_AVAILABLE_DASHBOARD,
  GET_USER_AVAILABLE_DASHBOARD_SUCCESS,
  GET_USER_AVAILABLE_DASHBOARD_FAILURE,
  MAP_DASHBOARD_AND_MENU_TO_USER,
  MAP_DASHBOARD_AND_MENU_TO_USER_SUCCESS,
  MAP_DASHBOARD_AND_MENU_TO_USER_FAILURE,
  GET_COMPANY_TO_USER_LIST_TEAM,
  GET_COMPANY_TO_USER_LIST_TEAM_SUCCESS,
  GET_COMPANY_TO_USER_LIST_TEAM_FAILURE,
  CREATE_COMPANY_TO_USER,
  CREATE_COMPANY_TO_USER_SUCCESS,
  CREATE_COMPANY_TO_USER_FAILURE,
  UPDATE_COMPANY_TO_USER_TEAM,
  UPDATE_COMPANY_TO_USER_TEAM_SUCCESS,
  UPDATE_COMPANY_TO_USER_TEAM_FAILURE,
  DELETE_COMPANY_TO_USER,
  DELETE_COMPANY_TO_USER_SUCCESS,
  DELETE_COMPANY_TO_USER_FAILURE,
  COMPANY_TO_USER_LOCK_USER,
  COMPANY_TO_USER_LOCK_USER_SUCCESS,
  COMPANY_TO_USER_LOCK_USER_FAILURE,
  COMPANY_TO_USER_UNLOCK_USER,
  COMPANY_TO_USER_UNLOCK_USER_SUCCESS,
  COMPANY_TO_USER_UNLOCK_USER_FAILURE,
  COMPANY_TO_USER_RESET_PASSWORD,
  COMPANY_TO_USER_RESET_PASSWORD_SUCCESS,
  COMPANY_TO_USER_RESET_PASSWORD_FAILURE,
  COMPANY_TO_USER_UPDATE_SUBSCRIPTION_LICENCE_AND_SECURITY,
  COMPANY_TO_USER_UPDATE_SUBSCRIPTION_LICENCE_AND_SECURITY_SUCCESS,
  COMPANY_TO_USER_UPDATE_SUBSCRIPTION_LICENCE_AND_SECURITY_FAILURE,
  GET_COMPANY_TO_USER_DATA,
  GET_COMPANY_TO_USER_DATA_SUCCESS,
  GET_COMPANY_TO_USER_DATA_FAILURE,
} from "./actionType";

// action for get company to user list

export const getCompanyToUserList = () => ({
  type: GET_COMPANY_TO_USER_LIST,
});

export const getCompanyToUserListSuccess = (companyToUserList) => ({
  type: GET_COMPANY_TO_USER_LIST_SUCCESS,
  payload: companyToUserList,
});

export const getCompanyToUserListFailure = (error) => ({
  type: GET_COMPANY_TO_USER_LIST_FAILURE,
  payload: error,
});

// action for switch company

export const switchCompany = (companyId) => ({
  type: SWITCH_COMPANY,
  payload: companyId,
});

export const switchCompanySuccess = (response) => ({
  type: SWITCH_COMPANY_SUCCESS,
  payload: response,
});

export const switchCompanyFailure = (error) => ({
  type: SWITCH_COMPANY_FAILURE,
  payload: error,
});

export const getCompanyUserInvitations = () => ({
  type: GET_COMPANY_USER_INVITATIONS,
});

export const getCompanyUserInvitationsSuccess = (companyUserInvitations) => ({
  type: GET_COMPANY_USER_INVITATIONS_SUCCESS,
  payload: companyUserInvitations,
});

export const getCompanyUserInvitationsFailure = (error) => ({
  type: GET_COMPANY_USER_INVITATIONS_FAILURE,
  payload: error,
});

export const sendEmailInvitation = (email) => ({
  type: SEND_EMAIL_INVITATION,
  payload: email,
});

export const sendEmailInvitationSuccess = (email) => ({
  type: SEND_EMAIL_INVITATION_SUCCESS,
  payload: email,
});

export const sendEmailInvitationFailure = (error) => ({
  type: SEND_EMAIL_INVITATION_FAILURE,
  payload: error,
});

export const getJoinCompanyInvitationList = () => ({
  type: GET_JOIN_COMPANY_INVITATION_LIST,
});

export const getJoinCompanyInvitationListSuccess = (
  joinCompanyInvitationList
) => ({
  type: GET_JOIN_COMPANY_INVITATION_LIST_SUCCESS,
  payload: joinCompanyInvitationList,
});

export const getJoinCompanyInvitationListFailure = (error) => ({
  type: GET_JOIN_COMPANY_INVITATION_LIST_FAILURE,
  payload: error,
});

// Accept Or Decline Invitation to join a company

export const acceptOrDeclineInvitationToJoinCompany = (payload) => ({
  type: ACCEPT_OR_DECLINE_INVITATION_TO_JOIN_COMPANY,
  payload,
});

export const acceptOrDeclineInvitationToJoinCompanySuccess = (payload) => ({
  type: ACCEPT_OR_DECLINE_INVITATION_TO_JOIN_COMPANY_SUCCESS,
  payload,
});

export const acceptOrDeclineInvitationToJoinCompanyFailure = (payload) => ({
  type: ACCEPT_OR_DECLINE_INVITATION_TO_JOIN_COMPANY_FAILURE,
  payload,
});

// Get Company Team Members List

export const getCompanyTeamMembersList = () => ({
  type: GET_COMPANY_TEAM_MEMBERS_LIST,
});

export const getCompanyTeamMembersListSuccess = (payload) => ({
  type: GET_COMPANY_TEAM_MEMBERS_LIST_SUCCESS,
  payload,
});

export const getCompanyTeamMembersListFailure = (payload) => ({
  type: GET_COMPANY_TEAM_MEMBERS_LIST_FAILURE,
  payload,
});

// Get Company Details

export const getCompanyDetails = () => ({
  type: GET_COMPANY_DETAILS,
});

export const getCompanyDetailsSuccess = (payload) => ({
  type: GET_COMPANY_DETAILS_SUCCESS,
  payload,
});

export const getCompanyDetailsFailure = (payload) => ({
  type: GET_COMPANY_DETAILS_FAILURE,
  payload,
});

// Update Company Details

export const updateCompanyDetails = (payload) => ({
  type: UPDATE_COMPANY_DETAILS,
  payload,
});

export const updateCompanyDetailsSuccess = (payload) => ({
  type: UPDATE_COMPANY_DETAILS_SUCCESS,
  payload,
});

export const updateCompanyDetailsFailure = (payload) => ({
  type: UPDATE_COMPANY_DETAILS_FAILURE,
  payload,
});

// User Available Menu

export const getUserAvailableMenu = () => ({ type: GET_USER_AVAILABLE_MENU });

export const getUserAvailableMenuSuccess = (payload) => ({
  type: GET_USER_AVAILABLE_MENU_SUCCESS,
  payload,
});

export const getUserAvailableMenuFailure = (payload) => ({
  type: GET_USER_AVAILABLE_MENU_FAILURE,
  payload,
});

// User Available Dashboard

export const getUserAvailableDashboard = () => ({
  type: GET_USER_AVAILABLE_DASHBOARD,
});

export const getUserAvailableDashboardSuccess = (payload) => ({
  type: GET_USER_AVAILABLE_DASHBOARD_SUCCESS,
  payload,
});

export const getUserAvailableDashboardFailure = (payload) => ({
  type: GET_USER_AVAILABLE_DASHBOARD_FAILURE,
  payload,
});

// Map Dashboard And Menu To User

export const mapDashboardAndMenuToUser = (payload) => ({
  type: MAP_DASHBOARD_AND_MENU_TO_USER,
  payload,
});

export const mapDashboardAndMenuToUserSuccess = (payload) => ({
  type: MAP_DASHBOARD_AND_MENU_TO_USER_SUCCESS,
  payload,
});

export const mapDashboardAndMenuToUserFailure = (payload) => ({
  type: MAP_DASHBOARD_AND_MENU_TO_USER_FAILURE,
  payload,
});

// Company To User List Team

export const getCompanyToUserListTeam = () => ({
  type: GET_COMPANY_TO_USER_LIST_TEAM,
});

export const getCompanyToUserListTeamSuccess = (payload) => ({
  type: GET_COMPANY_TO_USER_LIST_TEAM_SUCCESS,
  payload,
});

export const getCompanyToUserListTeamFailure = (payload) => ({
  type: GET_COMPANY_TO_USER_LIST_TEAM_FAILURE,
  payload,
});

// Create Company To User

export const createCompanyToUser = (payload) => ({
  type: CREATE_COMPANY_TO_USER,
  payload,
});

export const createCompanyToUserSuccess = (payload) => ({
  type: CREATE_COMPANY_TO_USER_SUCCESS,
  payload,
});

export const createCompanyToUserFailure = (payload) => ({
  type: CREATE_COMPANY_TO_USER_FAILURE,
  payload,
});

// Update Company To User Team

export const updateCompanyToUserTeam = (payload) => ({
  type: UPDATE_COMPANY_TO_USER_TEAM,
  payload,
});

export const updateCompanyToUserTeamSuccess = (payload) => ({
  type: UPDATE_COMPANY_TO_USER_TEAM_SUCCESS,
  payload,
});

export const updateCompanyToUserTeamFailure = (payload) => ({
  type: UPDATE_COMPANY_TO_USER_TEAM_FAILURE,
  payload,
});

// Delete Company To User

export const deleteCompanyToUser = (payload) => ({
  type: DELETE_COMPANY_TO_USER,
  payload,
});

export const deleteCompanyToUserSuccess = (payload) => ({
  type: DELETE_COMPANY_TO_USER_SUCCESS,
  payload,
});

export const deleteCompanyToUserFailure = (payload) => ({
  type: DELETE_COMPANY_TO_USER_FAILURE,
  payload,
});

// Lock User

export const companyToUserLockUser = (payload) => ({
  type: COMPANY_TO_USER_LOCK_USER,
  payload,
});

export const companyToUserLockUserSuccess = (payload) => ({
  type: COMPANY_TO_USER_LOCK_USER_SUCCESS,
  payload,
});

export const companyToUserLockUserFailure = (payload) => ({
  type: COMPANY_TO_USER_LOCK_USER_FAILURE,
  payload,
});

// Unlock User

export const companyToUserUnlockUser = (payload) => ({
  type: COMPANY_TO_USER_UNLOCK_USER,
  payload,
});

export const companyToUserUnlockUserSuccess = (payload) => ({
  type: COMPANY_TO_USER_UNLOCK_USER_SUCCESS,
  payload,
});

export const companyToUserUnlockUserFailure = (payload) => ({
  type: COMPANY_TO_USER_UNLOCK_USER_FAILURE,
  payload,
});

// Reset Password

export const companyToUserResetPassword = (payload) => ({
  type: COMPANY_TO_USER_RESET_PASSWORD,
  payload,
});

export const companyToUserResetPasswordSuccess = (payload) => ({
  type: COMPANY_TO_USER_RESET_PASSWORD_SUCCESS,
  payload,
});

export const companyToUserResetPasswordFailure = (payload) => ({
  type: COMPANY_TO_USER_RESET_PASSWORD_FAILURE,
  payload,
});

// Update Subscription Licence And Security

export const companyToUserUpdateSubscriptionLicenceAndSecurity = (payload) => ({
  type: COMPANY_TO_USER_UPDATE_SUBSCRIPTION_LICENCE_AND_SECURITY,
  payload,
});

export const companyToUserUpdateSubscriptionLicenceAndSecuritySuccess = (
  payload
) => ({
  type: COMPANY_TO_USER_UPDATE_SUBSCRIPTION_LICENCE_AND_SECURITY_SUCCESS,
  payload,
});

export const companyToUserUpdateSubscriptionLicenceAndSecurityFailure = (
  payload
) => ({
  type: COMPANY_TO_USER_UPDATE_SUBSCRIPTION_LICENCE_AND_SECURITY_FAILURE,
  payload,
});

// Get Company To User Data

export const getCompanyToUserData = (payload) => ({
  type: GET_COMPANY_TO_USER_DATA,
  payload,
});

export const getCompanyToUserDataSuccess = (payload) => ({
  type: GET_COMPANY_TO_USER_DATA_SUCCESS,
  payload,
});

export const getCompanyToUserDataFailure = (payload) => ({
  type: GET_COMPANY_TO_USER_DATA_FAILURE,
  payload,
});
